import { render, staticRenderFns } from "./TranscriptionSpan.vue?vue&type=template&id=27fcfc9e"
import script from "./TranscriptionSpan.vue?vue&type=script&lang=js"
export * from "./TranscriptionSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports